(function () {
  'use strict';

  // One owner for OUTRAGE primary and 2/3-pot actions, using the native form ID.
  var sanoPurchasePending = false;
  function purchaseForm() { return document.querySelector('form[data-sano-product-form="outrage-pre-workout"]'); }
  function purchaseQuantity(form){var input=form.closest('.sano-product-buybox').querySelector('[name="quantity"]');return input?input.value:1;}
  function selectedPurchase(form) {
    var control=form.querySelector('[name="id"]');
    var id = String(control?control.value:'');
    var config = {};
    try { config = JSON.parse(document.getElementById('SanoCartConfig').textContent); } catch (_) {}
    var variants=config.eligibleVariants || {};
    var section=form.closest('.sano-product-buybox');
    var mystery=section&&section.querySelector('[data-sano-mystery-preview][aria-pressed="true"]');
    var mysteryId=mystery&&String(mystery.dataset.mysteryVariantId||'');
    // The selected Mystery card must own the purchase, even after a legacy selector reset.
    if(mysteryId&&variants[mysteryId]&&variants[mysteryId].isMystery===true){
      id=mysteryId;if(control&&control.value!==id)control.value=id;
    }
    return {id:id,variant:variants[id]};
  }
  function purchaseStatus(form, text, failed) {
    var status = form.querySelector('[data-sano-purchase-status]');
    if (!status) { status = document.createElement('p'); status.dataset.sanoPurchaseStatus=''; status.className='product-form__status'; status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); status.setAttribute('tabindex','-1'); form.appendChild(status); }
    status.textContent=text; status.classList.toggle('visually-hidden',!failed);status.setAttribute('role',failed?'alert':'status');
  }
  function syncPurchaseControls() {
    var form=purchaseForm(); if(!form)return;
    var section=form.closest('.sano-product-buybox');
    var selection=selectedPurchase(form),button=section.querySelector('.btn--add-to-cart[name="add"]');
    if(button){
      var label=button.querySelector('.btn__text'); if(label&&label.textContent!=='IN WINKELWAGEN')label.textContent='IN WINKELWAGEN';
      var disabled=sanoPurchasePending||!selection.variant;
      if(button.disabled!==disabled)button.disabled=disabled;
      button.setAttribute('aria-busy',sanoPurchasePending?'true':'false');
      button.classList.toggle('is-adding',sanoPurchasePending);
    }
    section.querySelectorAll('[data-sano-quick-quantity]').forEach(function(b){b.disabled=sanoPurchasePending||!selection.variant;});
  }
  function addPurchase(form, quantity, trigger) {
    if(sanoPurchasePending)return;
    var selection=selectedPurchase(form);
    if(!selection.variant){purchaseStatus(form,'Kies een geldige OUTRAGE-smaak.',true);return;}
    quantity=Number(quantity);
    if(!Number.isSafeInteger(quantity)||quantity<1){purchaseStatus(form,'Kies een geldig aantal potten.',true);return;}
    if(!window.SanoCart||typeof window.SanoCart.addSelectedVariant!=='function'){purchaseStatus(form,'De winkelwagen wordt nog geladen. Probeer het zo opnieuw.',true);return;}
    sanoPurchasePending=true;syncPurchaseControls();purchaseStatus(form,'Toevoegen aan de winkelwagen…',false);
    window.SanoCart.addSelectedVariant(selection.id,quantity,trigger).then(function(){
      purchaseStatus(form,quantity+' '+(quantity===1?'pot':'potten')+' '+selection.variant.title+' toegevoegd aan je winkelwagen.',false);
    }).catch(function(error){purchaseStatus(form,error.message||'Toevoegen is niet gelukt. Controleer je winkelwagen voordat je opnieuw probeert.',true);})
      .finally(function(){sanoPurchasePending=false;syncPurchaseControls();});
  }
  // Capture before the legacy theme/TikTok add handlers. Never issue a second add.
  window.addEventListener('click',function(event){
    var trigger=event.target.closest&&event.target.closest('.sano-product-buybox .btn--add-to-cart[name="add"],.sano-product-buybox [data-sano-quick-quantity]');
    if(!trigger)return;var section=trigger.closest('.sano-product-buybox');var form=trigger.closest('form[data-sano-product-form="outrage-pre-workout"]')||(section&&section.querySelector('form[data-sano-product-form="outrage-pre-workout"]'));if(!form)return;
    event.preventDefault();event.stopImmediatePropagation();
    addPurchase(form,trigger.hasAttribute('data-sano-quick-quantity')?trigger.dataset.sanoQuickQuantity:purchaseQuantity(form),trigger);
  },true);
  window.addEventListener('submit',function(event){
    var form=event.target;if(!form.matches||!form.matches('form[data-sano-product-form="outrage-pre-workout"]'))return;
    event.preventDefault();event.stopImmediatePropagation();addPurchase(form,purchaseQuantity(form),event.submitter);
  },true);
  function initPurchase(){
    var form=purchaseForm();if(!form||form.dataset.sanoPurchaseBound)return;form.dataset.sanoPurchaseBound='true';syncPurchaseControls();
    form.addEventListener('change',function(){requestAnimationFrame(syncPurchaseControls);});
    var button=form.closest('.sano-product-buybox').querySelector('.btn--add-to-cart[name="add"]');if(button)new MutationObserver(syncPurchaseControls).observe(button,{attributes:true,attributeFilter:['disabled'],childList:true,subtree:true,characterData:true});
    document.addEventListener('sano:cart-ready',syncPurchaseControls);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPurchase);else initPurchase();
  document.addEventListener('shopify:section:load',initPurchase);

  function syncSanoQuickQuantities(form){
    syncPurchaseControls();
    var group=form.closest('.sano-product-buybox').querySelector('.sano-product-quick-quantities');if(!group)return;
    group.querySelectorAll('[data-sano-quick-quantity]').forEach(function(button){var label=button.parentElement.querySelector('.sano-quick-saving');if(!label)return;var campaign=window.SanoBfConcept;var unit=campaign&&campaign.enabled?Number(campaign.prices.reference)-Number(campaign.prices.sale):Number(label.dataset.unitSaving);label.hidden=!(unit>0);if(unit>0)label.textContent='Bespaar '+new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}).format(unit*Number(button.dataset.sanoQuickQuantity)/100)+'!';});
  }
  function disableSanoTicketLink(section){
    section.querySelectorAll('.sano-mystery-ticket-status a').forEach(function(link){link.removeAttribute('href');link.removeAttribute('tabindex');link.setAttribute('aria-disabled','true');});
  }
  function initSanoQuickQuantities(){
    document.querySelectorAll('form[data-sano-product-form="outrage-pre-workout"]').forEach(function(form){
      if(!form.closest('.sano-product-buybox').querySelector('.sano-product-quick-quantities') || form.dataset.sanoQuickBound)return;
      form.dataset.sanoQuickBound='true';syncSanoQuickQuantities(form);var section=form.closest('.sano-product-buybox');disableSanoTicketLink(section);new MutationObserver(function(){disableSanoTicketLink(section);}).observe(section,{childList:true,subtree:true});setTimeout(function(){syncSanoQuickQuantities(form);},1000);
      var observer=new MutationObserver(function(){syncSanoQuickQuantities(form);});
      observer.observe(form.closest('main'),{attributes:true,attributeFilter:['class']});
      var primary=form.closest('.sano-product-buybox').querySelector('[name="add"]');if(primary)observer.observe(primary,{attributes:true,attributeFilter:['disabled']});
      form.addEventListener('change',function(){requestAnimationFrame(function(){syncSanoQuickQuantities(form);});});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSanoQuickQuantities);else initSanoQuickQuantities();
  document.addEventListener('shopify:section:load',initSanoQuickQuantities);


  function initSanoStickyAtc() {
    var sticky = document.querySelector('[data-sano-sticky-cart]');
    var product = document.querySelector('.sano-product-buybox');

    if (!sticky || !product) return;

    var form = product.querySelector('form[data-product-form]');
    var primaryButton = form && form.querySelector('.btn--add-to-cart[name="add"]');

    if (!form || !primaryButton) return;

    var stickyButton = sticky.querySelector('[data-sano-sticky-submit]');

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (primaryButton.disabled) return;
        primaryButton.click();
      });
    }

    function setStickyVisibility(isPrimaryVisible, hasPassedPrimary) {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var shouldShow = isMobile && !isPrimaryVisible && hasPassedPrimary;

      sticky.hidden = !shouldShow;
      sticky.classList.toggle('is-visible', shouldShow);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setStickyVisibility(entry.isIntersecting, entry.boundingClientRect.bottom <= 0);
      }, { threshold: 0.15 });

      observer.observe(primaryButton);
      window.addEventListener('resize', function () {
        var rect = primaryButton.getBoundingClientRect();
        setStickyVisibility(rect.bottom > 0 && rect.top < window.innerHeight, rect.bottom <= 0);
      });
    } else {
      function checkPrimaryButton() {
        var rect = primaryButton.getBoundingClientRect();
        setStickyVisibility(rect.bottom > 0 && rect.top < window.innerHeight, rect.bottom <= 0);
      }

      window.addEventListener('scroll', checkPrimaryButton, { passive: true });
      window.addEventListener('resize', checkPrimaryButton);
      checkPrimaryButton();
    }
  }

  function initSanoInstructionsModal() {
    var trigger = document.querySelector('[data-sano-instructions-open]');
    var modal = document.querySelector('[data-sano-instructions-modal]');

    if (!trigger || !modal) return;

    var closeButtons = modal.querySelectorAll('[data-sano-instructions-close]');
    var closeButton = modal.querySelector('.sano-instructions-modal__close');

    function closeModal() {
      modal.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sano-modal-open');
      document.removeEventListener('keydown', handleKeydown);
      trigger.focus();
    }

    function handleKeydown(event) {
      if (event.key === 'Escape') closeModal();
    }

    function openModal() {
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sano-modal-open');
      document.addEventListener('keydown', handleKeydown);
      if (closeButton) closeButton.focus();
    }

    trigger.addEventListener('click', openModal);
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
  }

  function initSanoVariantMedia(root) {
    var product = (root || document).querySelector('.sano-product-buybox');
    if (!product) return;

    var gallery = product.querySelector('[data-sano-variant-gallery]');
    if (!gallery || gallery.dataset.sanoVariantMediaInitialised === 'true') return;
    gallery.dataset.sanoVariantMediaInitialised = 'true';
    var nativeGallery = gallery.querySelector('.js-product-media-group');
    var requestedVariantId = new URLSearchParams(window.location.search).get('variant');
    var mysteryIdAtLoad = product.querySelector('[data-sano-mystery-preview]')?.dataset.mysteryVariantId;
    var mysterySelected = requestedVariantId === mysteryIdAtLoad || (!requestedVariantId && product.hasAttribute('data-sano-mysterious-only'));
    var selectedMediaVariantId = gallery.dataset.selectedVariantId;
    function fitGalleryFrame() {
      if (!nativeGallery) return;
      // Anchor the frame to the primary pot, not the currently active slide.
      var primaryId = product.querySelector('[data-sano-mystery-preview]')?.dataset.mysteryVariantId;
      var primary = nativeGallery.querySelector('[data-sano-primary-media="true"] img.mfp-image');
      if (!primaryId || !primary) primary = nativeGallery.querySelector('img.mfp-image');
      if (!primary) return;
      var width = Number(primary.getAttribute('width')) || primary.naturalWidth;
      var height = Number(primary.getAttribute('height')) || primary.naturalHeight;
      if (width > 0 && height > 0) gallery.style.setProperty('--sano-source-aspect', width + ' / ' + height);
    }
    function filterSelectedMedia() {
      if (!nativeGallery || !window.jQuery || !window.jQuery(nativeGallery).hasClass('slick-initialized')) return;
      var selectedId = String(selectedMediaVariantId || '');
      var slider = window.jQuery(nativeGallery);
      slider.slick('slickUnfilter');
      var sourceSlides = slider.slick('getSlick').$slides;
      sourceSlides.sort(function (a, b) {
        var key = mysterySelected ? 'sanoMysteryOrder' : 'sanoProductOrder';
        return Number(a.dataset[key]) - Number(b.dataset[key]);
      });
      slider.slick('slickFilter', function () {
        var mystery = this.dataset.sanoMysteryMedia === 'true';
        var variants = (this.dataset.sanoMediaVariants || '').split('|').filter(Boolean);
        var general = this.dataset.sanoGeneralMedia === 'true';
        var show = general || (mysterySelected ? mystery : variants.indexOf(selectedId) !== -1);
        this.hidden = !show;
        return show;
      });
      slider.slick('slickGoTo', 0, true);
      fitGalleryFrame();
      slider.slick('setPosition');
    }
    if (nativeGallery) nativeGallery.addEventListener('load', fitGalleryFrame, true);
    if (nativeGallery && window.jQuery) {
      window.jQuery(nativeGallery).on('afterChange.sanoSourceMedia', fitGalleryFrame);
      window.jQuery(nativeGallery).on('init.sanoSourceMedia', function () { window.setTimeout(filterSelectedMedia, 0); });
      window.jQuery(product).on('variantChange.sanoSourceMedia', function (event) {
        selectedMediaVariantId = event.variant && event.variant.id || selectedMediaVariantId;
        mysterySelected = String(selectedMediaVariantId) === String((product.querySelector('[data-sano-mystery-preview]') || {}).dataset?.mysteryVariantId || '');
        window.setTimeout(filterSelectedMedia, 0);
      });
    }
    window.addEventListener('load', filterSelectedMedia, { once: true });
    var mysteryButton = product.querySelector('[data-sano-mystery-preview]');
    if (mysteryButton) mysteryButton.addEventListener('click', function () {
      mysterySelected = true;
      var nativeId = mysteryButton.dataset.mysteryVariantId;
      if (nativeId) {
        selectedMediaVariantId = nativeId;
        var idInput = product.querySelector('form[data-product-form] [name="id"]');
        if (idInput) idInput.value = nativeId;
        var jsonNode = product.querySelector('[id^="ProductJson-"]');
        if (!jsonNode) jsonNode = document.querySelector('[id^="ProductJson-"]');
        if (jsonNode && window.jQuery) {
          try { var nativeVariant = JSON.parse(jsonNode.textContent).variants.find(function (v) { return String(v.id) === String(nativeId); });
            if (nativeVariant) window.jQuery(product).trigger({type: 'variantChange', variant: nativeVariant});
          } catch (error) { /* Keep the existing preview usable if source JSON is absent. */ }
        }
      }
      filterSelectedMedia();
    });
    filterSelectedMedia();
    var selectedFlavorAtLoad = gallery.dataset.selectedFlavor || 'red-moon';
    var flavorEffectTimer;

    function playFlavorEffect(selectedFlavor) {
      if (selectedFlavor !== 'red-moon' && selectedFlavor !== 'blueberry-ice') return;

      window.clearTimeout(flavorEffectTimer);
      product.removeAttribute('data-sano-flavour-effect');
      void product.offsetWidth;
      product.setAttribute('data-sano-flavour-effect', selectedFlavor);

      flavorEffectTimer = window.setTimeout(function () {
        product.removeAttribute('data-sano-flavour-effect');
      }, 520);
    }

    function updateVariantMedia(allowFlavorEffect) {
      var checkedInput = product.querySelector('[data-sano-flavor] input[type="radio"]:checked');
      var flavorControl = checkedInput && checkedInput.closest('[data-sano-flavor]');
      var selectedFlavor = flavorControl && flavorControl.dataset.sanoFlavor;
      var galleryFlavor = selectedFlavor;

      if (
        allowFlavorEffect &&
        (selectedFlavor === 'red-moon' || selectedFlavor === 'blueberry-ice') &&
        selectedFlavor !== selectedFlavorAtLoad
      ) {
        playFlavorEffect(selectedFlavor);
      }
      selectedFlavorAtLoad = selectedFlavor;

      gallery.dataset.selectedFlavor = galleryFlavor;
      gallery.querySelectorAll('[data-sano-variant-media]').forEach(function (media) {
        media.hidden = media.dataset.sanoVariantMedia !== galleryFlavor;
      });

      var variantLabel = checkedInput && checkedInput.closest('.variants-wrapper');
      variantLabel = variantLabel && variantLabel.querySelector('.variants__label span');
      if (variantLabel) {
        variantLabel.textContent = checkedInput.value;
      }
    }

    product.addEventListener('change', function (event) {
      if (event.target.matches('[data-sano-flavor] .js-single-option-selector')) {
        updateVariantMedia(true);
      }
    });

    updateVariantMedia(false);
  }

  function initSanoDeliverySuccess() {
    if (document.documentElement.dataset.sanoDeliverySuccessInitialised === 'true') return;
    document.documentElement.dataset.sanoDeliverySuccessInitialised = 'true';

    var resetTimer;

    document.addEventListener('sano:cart-item-added', function () {
      var delivery = document.querySelector('.sano-product-buybox .estimated_delivery');
      var truck = delivery && delivery.querySelector('.icons');
      if (!delivery || !truck) return;

      window.clearTimeout(resetTimer);
      delivery.classList.remove('is-sano-add-success');
      delivery.style.setProperty('--sano-delivery-travel', Math.max(0, delivery.clientWidth - truck.offsetWidth - 36) + 'px');
      void delivery.offsetWidth;
      delivery.classList.add('is-sano-add-success');

      resetTimer = window.setTimeout(function () {
        delivery.classList.remove('is-sano-add-success');
        delivery.style.removeProperty('--sano-delivery-travel');
      }, 1250);
    });
  }

  function initSanoPriceReveal(root) {
    var scope = root || document;
    var buybox = scope.matches && scope.matches('.sano-product-buybox')
      ? scope
      : scope.querySelector('.sano-product-buybox');
    if (!buybox) return;

    var price = buybox.querySelector('.price-single-product [data-sano-price-reveal]');
    if (!price || price.dataset.sanoPriceRevealInitialised === 'true') return;
    if(window.SanoBfConcept && window.SanoBfConcept.productConcept)return;

    var product = buybox.querySelector('.product[data-section-id]');
    var variantSelect = buybox.querySelector('form[data-product-form] select[name="id"]');
    var layer = price.querySelector('[data-sano-price-reveal-layer]');
    var counter = price.querySelector('[data-sano-price-reveal-counter]');
    var productJson = product && document.getElementById('ProductJson-' + product.dataset.sectionId);
    var variants;

    try {
      variants = productJson ? JSON.parse(productJson.textContent).variants : null;
    } catch (error) {
      variants = null;
    }

    if (!variantSelect || !layer || !counter || !variants || !variants.length) return;
    price.dataset.sanoPriceRevealInitialised = 'true';

    var observer;
    var animationFrame;
    var settleTimer;
    var isIntersecting = false;
    var hasRevealed = false;
    var isRunning = false;
    var countdownDuration = 1600;
    var costLabel=price.querySelector('[data-sano-bf-cost-label]');
    var isPreview = price.hasAttribute('data-sano-preview-price');
    function bfEligible(v){return isPreview || !!(v&&v.price===1999&&v.compare_at_price===4299&&price.dataset.sanoBfReference==='true'&&price.dataset.sanoBfCurrency==='EUR');}
    function updateBf(v){var active=bfEligible(v);price.classList.toggle('sano-bf-price',active);if(costLabel)costLabel.hidden=!(price.classList.contains('sano-pdp-concept')||(active&&(isPreview||price.dataset.sanoBfCost==='true')));var badge=price.querySelector('[data-discount-badge]');if(active&&badge)badge.textContent=Math.floor((v.compare_at_price-v.price)/v.compare_at_price*100)+'% KORTING';return active;}
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function currentVariant() {
      var selectedId = String(variantSelect.value);
      var selected = variants.find(function (variant) {
        return String(variant.id) === selectedId;
      });
      return selected;
    }

    function isSaleVariant(variant) {
      return updateBf(variant);
    }

    var priceFormatter = new Intl.NumberFormat('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    function formatCents(cents) {
      return (isPreview ? 'Ã¢â€šÂ¬' : '') + priceFormatter.format(cents / 100);
    }
    counter.style.fontVariantNumeric = 'tabular-nums';
    var priceText = null, lastDisplayedCents = null;
    function writePrice(cents) {
      if (lastDisplayedCents === cents && priceText && priceText.parentNode === counter) return;
      lastDisplayedCents = cents;
      var value = formatCents(cents);
      if (!priceText || priceText.parentNode !== counter) {
        counter.textContent = value;
        priceText = counter.firstChild;
      } else priceText.data = value;
    }

    function clearMotion() {
      if (animationFrame) window.cancelAnimationFrame(animationFrame);
      if (settleTimer) window.clearTimeout(settleTimer);
      animationFrame = null;
      settleTimer = null;
    }

    function showStaticEndState() {
      updateBf(currentVariant());
      clearMotion();
      if (observer) observer.disconnect();
      price.classList.remove('sano-price-reveal--ready', 'sano-price-reveal--running', 'sano-price-reveal--settling');
      price.classList.add('sano-price-reveal--complete');
      isRunning = false;
      hasRevealed = true;
    }

    function prepare(variant) {
      if (!isSaleVariant(variant)) {
        showStaticEndState();
        return false;
      }

      var typography = getComputedStyle(price.querySelector('[data-product-price]'));
      ['fontSize','fontFamily','fontWeight','lineHeight','letterSpacing'].forEach(function(key){counter.style[key] = typography[key];});
      writePrice(variant.price);
      price.classList.remove('sano-price-reveal--complete');
      price.classList.add('sano-price-reveal--ready');
      return true;
    }

    function settle() {
      isRunning = false;
      price.classList.remove('sano-price-reveal--running');
      price.classList.add('sano-price-reveal--settling');
      settleTimer = window.setTimeout(showStaticEndState, 620);
    }

    function startReveal() {
      if (hasRevealed || isRunning || document.hidden) return;

      var variant = currentVariant();
      if (!prepare(variant)) return;

      var startPrice = variant.price;
      var endPrice = variant.price;
      var startTime;
      isRunning = true;
      if (observer) observer.disconnect();
      price.classList.add('sano-price-reveal--running');

      function tick(timestamp) {
        if (!isRunning) return;
        if (!startTime) startTime = timestamp;

        var progress = Math.min((timestamp - startTime) / countdownDuration, 1);
        var easedProgress = 1 - Math.pow(1 - progress, 3);
        var displayedPrice = Math.round(startPrice + ((endPrice - startPrice) * easedProgress));
        writePrice(displayedPrice);

        if (progress < 1) {
          animationFrame = window.requestAnimationFrame(tick);
        } else {
          writePrice(endPrice);
          settle();
        }
      }

      animationFrame = window.requestAnimationFrame(tick);
    }

    function handleVariantChange(event) {
      if (!event.target.matches('.js-single-option-selector, select[name="id"]')) return;

      window.setTimeout(function () {
        updateBf(currentVariant());
        if (hasRevealed) return;
        if (isRunning) {
          showStaticEndState();
          return;
        }

        if (prepare(currentVariant()) && isIntersecting) startReveal();
      }, 0);
    }

    function handleVisibilityChange() {
      if (document.hidden && isRunning) showStaticEndState();
    }

    function cleanup() {
      clearMotion();
      if (observer) observer.disconnect();
      buybox.removeEventListener('change', handleVariantChange);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      price.removeAttribute('data-sano-price-reveal-initialised');
      delete price._sanoPriceRevealCleanup;
    }

    price._sanoPriceRevealCleanup = cleanup;
    buybox.addEventListener('change', handleVariantChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (reduceMotion || !('IntersectionObserver' in window) || !prepare(currentVariant())) {
      showStaticEndState();
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      isIntersecting = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
      if (isIntersecting) startReveal();
    }, { threshold: [0.35] });
    observer.observe(price);
  }

  function initSanoOutrageReviewDeduplication() {
    if (!document.querySelector('.sano-native-reviews')) return;
    // Only the known legacy Judge.me summary headers; never scan or rewrite
    // review bodies, Trustoo statistics, photos or individual ratings.
    function removeLegacyHeaders() {
      document.querySelectorAll('.sano-product-buybox .jdgm-preview-badge, .sano-product-buybox .sano-product-social-proof, .jdgm-rev-widg__summary, .jdgm-histogram, .jdgm-row-stars').forEach(function(node){node.remove();});
    }
    removeLegacyHeaders();
    if (!window.__sanoLegacyHeaderEvent) {
      window.__sanoLegacyHeaderEvent = true;
      document.addEventListener('onTrustooReviewsEmbed', removeLegacyHeaders);
    }
  }

  function initSanoProduct() {
    initSanoOutrageReviewDeduplication();
    initSanoStickyAtc();
    initSanoInstructionsModal();
	initSanoVariantMedia(document);
    initSanoPriceReveal(document);
    initSanoDeliverySuccess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSanoProduct);
  } else {
    initSanoProduct();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSanoOutrageReviewDeduplication();
    initSanoVariantMedia(event.target);
    initSanoPriceReveal(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var price = event.target.querySelector('[data-sano-price-reveal]');
    if (price && price._sanoPriceRevealCleanup) price._sanoPriceRevealCleanup();
  });
})();
